import React from 'react';
import { theme } from '../../config/theme';

const STATUS_CONFIG = {
  active:    { label: 'Active',    bg: '#d1fae5', color: '#065f46' },
  expired:   { label: 'Expired',   bg: '#fee2e2', color: '#991b1b' },
  cancelled: { label: 'Cancelled', bg: '#f3f4f6', color: '#374151' },
  pending:   { label: 'Pending',   bg: '#fef3c7', color: '#92400e' },
};

const SubscriptionStatusBadge = ({ status, style = {} }) => {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.pending;

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      padding: `2px ${theme.spacing.sm}`,
      borderRadius: theme.borderRadius.full,
      fontSize: theme.typography.fontSize.xs,
      fontWeight: theme.typography.fontWeight.semibold,
      backgroundColor: cfg.bg,
      color: cfg.color,
      textTransform: 'capitalize',
      ...style,
    }}>
      {cfg.label}
    </span>
  );
};

export default SubscriptionStatusBadge;